import React from 'react';
import {connect} from 'react-redux'
import * as actions from '../../store/actions'
import { useLocation, useNavigate } from 'react-router'
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Button, Divider, Fab } from '@mui/material';

const FeedbackWidget = props => {
  const { 
    onOpenFeedbackDialog,
    onCloseDialog,
    onChooseAdd,
    dialog_id,
    onInializeAddMerchant
  } = props;

  let navigate = useNavigate()
  
  const handleDialogClose = () => {
    onCloseDialog()
    // onInializeAddMerchant()
  };

  const handleClick = () => {
    onOpenFeedbackDialog()
  };

  const fabStyle = {
    position: 'fixed',
    bottom: 20,
    right: 20,
    width: '20px !important',
    '&:hover': {
        width: '260px !important'
    },
    'span': {
        display: 'none'
    },
    '&:hover span': {
        display: 'block',
        paddingLeft: '10px'
    }
  };

  return (
    <Fab variant="extended" sx={fabStyle} color='primary'>
        <QuestionMarkIcon onClick={handleClick} />
        <span onClick={handleClick}>Questions and Feedback</span>
    </Fab>
  );
};

const mapStateToProps = state => {
  return {
    // openDialog: state.merchant.merchant_exists_dialog_open,
    // dialog_id: state.merchant.dialog_id
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onCloseFeedbackDialog: () => dispatch(actions.closeFeedbackDialog()),
    onOpenFeedbackDialog: () => dispatch(actions.openFeedbackDialog()),
    onInializeAddMerchant: () => dispatch(actions.initializeAddMerchant())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackWidget)
